import DefaultDataFetcherFactory from "app/components/widget/widget-fetchers/DefaultDataFetcher";
import DurationService, { BasicDurations } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

function dataFetcherFactory(widget) {
    const internalFetcher = DefaultDataFetcherFactory.create(widget);

    // we don't support 28d in the mobile anymore  so for the users that have it
    // we convert them to 1 month data
    if (
        widget.apiParams.webSource === devicesTypes.MOBILE &&
        widget.apiParams.latest === BasicDurations.LAST_TWENTY_EIGHT_DAYS
    ) {
        const monthDuration = DurationService.getDurationData(BasicDurations.LAST_MONTH);
        widget.apiParams.from = monthDuration.forAPI.from;
        widget.apiParams.to = monthDuration.forAPI.to;
        widget.apiParams.isWindow = false;
        delete widget.apiParams.latest;
    }

    let includeTerms;
    if (widget.apiParams.selectedPhrase) {
        includeTerms = widget.apiParams.IncludeTerms
            ? widget.apiParams.IncludeTerms + `,${widget.apiParams.selectedPhrase}`
            : widget.apiParams.selectedPhrase;
    }

    return {
        fetch() {
            const endPointFinalFilters = includeTerms
                ? { ...widget.apiParams, IncludeTerms: includeTerms }
                : widget.apiParams;
            return internalFetcher.fetch(endPointFinalFilters).then((data) => {
                return data;
            });
        },
        destroy() {},
    };
}
export default class {
    create(widget) {
        return dataFetcherFactory(widget);
    }
}
